exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_textContainer__qxe7b{position:relative;display:flex;align-items:flex-end}.style_iconContainer__1baDV{position:absolute;right:0;cursor:pointer;margin:.5625rem;top:18px}.style_autoCompleteContainer__3JypX{width:100%}.style_popover__smxSz>div,.style_popoverContent__3lIcb{overflow-x:hidden}.style_popoverInfoText__2oEe8{margin:1rem}.style_warning__3Z_HM{margin:.5rem 1rem;color:#fb8c00;font-size:.75rem}.style_buttons__30ybd{padding-bottom:.5rem}", ""]);

// exports
exports.locals = {
	"textContainer": "style_textContainer__qxe7b",
	"iconContainer": "style_iconContainer__1baDV",
	"autoCompleteContainer": "style_autoCompleteContainer__3JypX",
	"popover": "style_popover__smxSz",
	"popoverContent": "style_popoverContent__3lIcb",
	"popoverInfoText": "style_popoverInfoText__2oEe8",
	"warning": "style_warning__3Z_HM",
	"buttons": "style_buttons__30ybd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/AutoComplete/style.less
// module id = 1831
// module chunks = 8